import { render, staticRenderFns } from "./YouTubeVideo.vue?vue&type=template&id=3c23d3f8&"
import script from "./YouTubeVideo.vue?vue&type=script&lang=js&"
export * from "./YouTubeVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {YouTubeVideo: require('/usr/src/motec/components/YouTubeVideo.vue').default})
